var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_100",
    fill: "#fff",
    stroke: "#2e2d79",
    "data-name": "Rectangle 100"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0H18V18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0.5 0.5H17.5V17.5H0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxPurple);
export default __webpack_public_path__ + "static/media/checkbox-purple.ea9120be262ae5b5f0a3c67ebac8c606.svg";
export { ForwardRef as ReactComponent };